import OapCard from './code/Scripts/components/OapCard.vue';

export default {
  components: {
    OapCard,
  },
};
